module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('email-edit-modal', {
    attrs: {
      "nums": _vm.nums,
      "users": _vm.users,
      "states": _vm.states,
      "usersession": _vm.usersession,
      "email_current": _vm.email_current,
      "email_id": _vm.email_current || _vm.route.query.email
    },
    on: {
      "emailEdited": function($event) {
        return _vm.emailEdited()
      },
      "closeEditEmail": function($event) {
        return _vm.closeEditEmail()
      }
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.path !== '/admin/pendings-emails') ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Cortes "), _c('app-title-custom'), _vm._v(" (" + _vm._s(_vm.filteredEmails.length) + ")\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": "search",
      "classname": "w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown hidden md:block md:absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-down",
      "classname": "dropdown-toggle w-4 h-4 mt-3 cursor-pointer text-gray-700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return (state.id != 7) ? _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                        " + _vm._s(state.name) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Fecha entrega")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Codigo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Creada por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.created_by),
      expression: "filter.created_by"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "created_by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Seleccione un usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsersAccount), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                        " + _vm._s(user.name) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                        Borrar Filtro\n                      ")])])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-y mb-4 flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [(_vm.user.team_id == 1) ? _c('email-download-list-button', {
    attrs: {
      "classname": 'mr-2'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1",
    class: _vm.completed_emails ?
      'bg-theme-1 text-white' :
      'border border-theme-1 border-theme-10 text-theme-10',
    on: {
      "click": function($event) {
        return _vm.viewEmailFinish()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.completed_emails ?
    'Quitar cortes finalizados' :
    'Ver cortes finalizados') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.setCreateEmailModal(true)
      }
    }
  }, [_vm._v("\n              Crear Corte\n            ")])], 1)])])]) : _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 zindex-0 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n        Cortes Pendientes\n        "), (_vm.account_session) ? _c('app-title-custom') : _vm._e(), _vm._v("\n        (" + _vm._s(_vm.filteredEmails.length) + ")\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('all')
      }
    }
  }, [_vm._v("\n          Ver todas las cuentas\n        ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('one')
      }
    }
  }, [_vm._v("\n          Ver solo una cuenta\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report mt-8"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredEmails), function(email) {
    return _c('tr', {
      staticClass: "intro-x zindex-0"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      class: email.urgent == true ? 'text-red-700' : '',
      attrs: {
        "href": "#"
      }
    }, [_vm._v("\n                " + _vm._s(email.urgent == true ? 'URG-' : '') + _vm._s(_vm._f("limit")(email.name.toUpperCase())) + " - " + _vm._s(email.number) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(email.slug) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(email.created_at) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center w-40"
    }, [_c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v("\n                " + _vm._s(email.campaign_attribute.project_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v("\n                " + _vm._s(email.campaign_attribute.project_account_name) + " -\n                " + _vm._s(email.campaign_attribute.project_account_country_prefix) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-sm whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(email.campaign_attribute.name) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(email.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (email.id) + "-1"),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_created_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": email.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(email.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (email.id) + "-2"),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": email.user_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(email.reviewed_by === user.id) ? _c('div', {
        key: ("user-user_id-" + (email.id) + "-3"),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": user.name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": user.name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v("\n                " + _vm._s(email.state_name) + _vm._s(email.hours ? (" - " + (email.hours) + " hs") : '') + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: _vm.dateClass(email)
    }, [_vm._v("\n                " + _vm._s(email.date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('a', {
      staticClass: "cursor-pointer flex items-center pr-3",
      on: {
        "click": function($event) {
          return _vm.showEmailClassification(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "file",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Tipos\n                ")], 1), _vm._v("\n                 \n                "), (email.state_id >= 5) ? _c('a', {
      staticClass: "cursor-pointer flex items-center pr-3",
      on: {
        "click": function($event) {
          return _vm.viewEmail(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-5 h-5 mr-2"
      }
    }), _vm._v(" Ver\n                ")], 1) : _vm._e(), _vm._v("\n                 \n                "), (email.state_id != 6) ? _c('div', [(
      email.campaign_attribute.account_id ==
      _vm.auth_session_account
    ) ? _c('button', {
      staticClass: "cursor-pointer flex items-center pr-3",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editElement(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Editar\n                  ")], 1) : _c('button', {
      staticClass: "cursor-pointer flex items-center pr-3",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.viewAccountEmail(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Editar\n                  ")], 1)]) : _vm._e(), _vm._v(" "), (email.state_id >= 5) ? _c('router-link', {
      staticClass: "cursor-pointer flex items-center pr-3",
      attrs: {
        "to": ("/admin/emails-check/" + (email.id))
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Check\n                ")], 1) : _vm._e()], 1)])])
  }), 0)])])], 1) : _c('app-loading'), _vm._v(" "), (_vm.createEmailModal) ? _c('CreateEmailModal', {
    attrs: {
      "nums": _vm.nums,
      "email": _vm.email,
      "user": _vm.user
    },
    on: {
      "closeModal": function($event) {
        return _vm.setCreateEmailModal(false)
      },
      "emailCreated": function($event) {
        return _vm.emailCreated()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.emailClassification) ? _c('EmailClassificationModal', {
    attrs: {
      "email": _vm.emailClassification
    },
    on: {
      "closeModal": function($event) {
        return _vm.closeEmailClassificationModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.email_view) ? _c('ViewEmailModal', {
    attrs: {
      "email": _vm.email_view,
      "versions": _vm.email_view.versions
    },
    on: {
      "closeModal": function($event) {
        _vm.email_view = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA ENTREGA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d4a3052","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/email/EmailTeam.vue
// module id = 466
// module chunks = 1